var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconEstimate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5667 7.15002V12.85C17.5667 13.7833 17.0667 14.65 16.2584 15.125L11.3084 17.9834C10.5 18.45 9.50005 18.45 8.68338 17.9834L3.73338 15.125C2.92505 14.6584 2.42505 13.7917 2.42505 12.85V7.15002C2.42505 6.21669 2.92505 5.34998 3.73338 4.87498L8.68338 2.01666C9.49172 1.54999 10.4917 1.54999 11.3084 2.01666L16.2584 4.87498C17.0667 5.34998 17.5667 6.20835 17.5667 7.15002Z",
    stroke: "#223A58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.16667C11.0724 9.16667 11.9417 8.29734 11.9417 7.22499C11.9417 6.15263 11.0724 5.28336 10 5.28336C8.92766 5.28336 8.05835 6.15263 8.05835 7.22499C8.05835 8.29734 8.92766 9.16667 10 9.16667Z",
    stroke: "#223A58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 13.8833C13.3333 12.3833 11.8416 11.1667 9.99996 11.1667C8.15829 11.1667 6.66663 12.3833 6.66663 13.8833",
    stroke: "#223A58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconEstimate);
export default __webpack_public_path__ + "static/media/common_icon_estimate.af989217aa2e267f5cd07d64df5e5231.svg";
export { ForwardRef as ReactComponent };